// extracted by mini-css-extract-plugin
export var contained = "VideoPlayer-module--contained--e2653";
export var playerWrapper = "VideoPlayer-module--playerWrapper--2b790";
export var reactPlayer = "VideoPlayer-module--reactPlayer--f99b3";
export var videoplayer = "VideoPlayer-module--videoplayer--94167";